import { useState } from 'react';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { NavTabs } from '@components/NavTabs';
import { useTranslation } from '@hooks';
import { RoutePath } from '@constants/routes';
import KnowledgeBase from './KnowledgeBase';
import Agents from './Agents';

const Container = styled('div')({
    '@media (max-width: 1024px)': {
        padding: 16,
    },
});

const PulseAI = () => {
    const { pathname } = useLocation();
    const [currentTab, setCurrentTab] = useState(pathname);
    const { t } = useTranslation();

    const availableTabs = [
        { label: t('Sidebar.agents'), value: RoutePath.MessagingPulseAIAgents },
        { label: t('Sidebar.knowledgeBase'), value: RoutePath.MessagingPulseAIKnowledgeBase },
    ];

    const RouteMap = {
        [RoutePath.MessagingPulseAIAgents]: 0,
        [RoutePath.MessagingPulseAIKnowledgeBase]: 1,
    };

    return (
        <Container>
            <NavTabs
                tabLinks={availableTabs}
                onTabClick={selectedTab => setCurrentTab(selectedTab)}
                currentTabIndex={RouteMap[currentTab]}
            />
            <Switch>
                <Route path={RoutePath.MessagingPulseAIKnowledgeBase} component={KnowledgeBase} />
                <Route path={RoutePath.MessagingPulseAIAgents} component={Agents} />
                <Redirect from={RoutePath.MessagingPulseAI} to={RoutePath.MessagingPulseAIAgents} />
            </Switch>
        </Container>
    );
};

export default PulseAI;
